import gql from 'graphql-tag';

const unarchiveOutputQuery = gql`
  mutation UnarchiveOutput($outputId: String!) {
    unarchiveOutput(outputId: $outputId) {
      archivedAt
      outputId
    }
  }
`;

const unarchiveOutput = {
  mutation: unarchiveOutputQuery,
  module: 'video',
  buildVariables: (outputId: string) => ({ outputId })
} as const;

export default unarchiveOutput;
